import PageNotFound from "../components/PageNotFound"

const Error404Page = () => {
    return (
			<PageNotFound />
    )
}

export default Error404Page;